<template>
  <v-dialog
    v-model="isOpen"
    max-width="700"
    @input="handleClose"
  >
    <v-card>
      <v-card-title class="headline pb-10">
        Вы точно хотите удалить выбранный шаблон {{currentTemplate.name}}?
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close()">Закрыть</v-btn>
        <v-btn text color="primary" @click="deleteTemplate()">Удалить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import OverlayLoader from '@/app/shared/components/app-loader/Loader';

export default {
  name: 'confirmDeletionModal',
  components: {
    OverlayLoader,
  },
  data() {
    return {
    };
  },
  computed: {
    isOpen: {
      get(){
        return this.$store.getters.IS_CONFIRM_DELETION_TEMPLATE_MODAL_OPENED;
      },
      set(){
        this.$store.dispatch('CONFIRM_DELETION_TEMPLATE_MODAL', false);
      }
    },
    currentTemplate: {
      get(){
        return this.$store.getters.GET_CURRENT_TEMPLATE;
      },
      set(value){
        this.$store.commit("SET_CURRENT_TEMPLATE", value);
      }
    },
  },
  methods: {
    close() {
      this.$store.dispatch('CONFIRM_DELETION_TEMPLATE_MODAL', false);
    },
    deleteTemplate(){
      this.$store.dispatch('DELETE_TEMPLATE', this.currentTemplate.id)
        .then(() => {
          this.$toast.success('Шаблон был удален');
          this.$store.dispatch('CONFIRM_DELETION_TEMPLATE_MODAL', false);
        })
        .catch(() => {
          this.$toast.error('Неизвестная ошибка');
        });

        // "обнуление" выбранного шаблона
        this.$store.dispatch("CURRENT_TEMPLATE", { type: "app" });
    },
    handleClose(isOpen) {
      if (!isOpen) {
        this.close();
      }
    }
  },
};
</script>
